<template>
  <div class="agenda-expanded">
    <p class="s-heading pl-2">TOPICS</p>
    <p v-html="panelInfo.topics"></p>
    <b-card no-body class="mb-1 mt-2">
      <b-card-header v-b-toggle.panel-speakers-1 header-tag="header" role="tab">
        <div class="text-center">
          Moderators
          <i class="fas fa-chevron-up" />
          <i class="fas fa-chevron-down" />
        </div>
      </b-card-header>
      <b-collapse id="panel-speakers-1" accordion="my-accordion" role="tabpanel">
        <div
          class="speaker-row"
          v-for="{ customer, details } in getSpeakers('moderator')"
          :key="customer"
        >
          <div class="speaker-photo-container">
            <img class="moderator-photo" :src="details.prof_pic" alt="" />
          </div>
          <div class="speaker-info-container pl-1">
            <router-link :to="{name: 'userProfilePage', params: { customerId: details.company_id }}">
              <p class="speaker-username">{{ details.name }}</p>
            </router-link>
            <p class="speaker-position">{{ details.job_title }}</p>
            <router-link :to="{name: 'companyProfile', params: { companyId: details.company_id }}">
              <p class="speaker-company">{{ details.company }}</p>
            </router-link>
          </div>
        </div>
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-1">
      <b-card-header v-b-toggle.panel-speakers-2 header-tag="header" role="tab">
        <div class="text-center">
          Keynote Speakers
          <i class="fas fa-chevron-up" />
          <i class="fas fa-chevron-down" />
        </div>
      </b-card-header>
      <b-collapse id="panel-speakers-2" accordion="my-accordion" role="tabpanel">
        <div
          class="speaker-row"
          v-for="{ customer, details } in getSpeakers('keynote_speaker')"
          :key="customer"
        >
          <div class="speaker-photo-container">
            <img class="moderator-photo" :src="details.prof_pic" alt="" />
          </div>
          <div class="speaker-info-container pl-1">
            <router-link :to="{name: 'userProfilePage', params: { customerId: details.company_id }}">
              <p class="speaker-username">{{ details.name }}</p>
            </router-link>
            <p class="speaker-position">{{ details.job_title }}</p>
            <router-link :to="{name: 'companyProfile', params: { companyId: details.company_id }}">
              <p class="speaker-company">{{ details.company }}</p>
            </router-link>
          </div>
        </div>
      </b-collapse>
    </b-card>
    <b-card no-body class="mb-1">
      <b-card-header v-b-toggle.panel-speakers-3 header-tag="header" role="tab">
        <div class="text-center">
          Panelists
          <i class="fas fa-chevron-up" />
          <i class="fas fa-chevron-down" />
        </div>
      </b-card-header>
      <b-collapse id="panel-speakers-3" accordion="my-accordion" role="tabpanel">
        <div
          class="speaker-row"
          v-for="{ customer, details } in getSpeakers('panelist')"
          :key="customer"
        >
          <div class="speaker-photo-container">
            <img class="moderator-photo" :src="details.prof_pic" alt="" />
          </div>
          <div class="speaker-info-container pl-1">
            <router-link :to="{name: 'userProfilePage', params: { customerId: details.company_id }}">
              <p class="speaker-username">{{ details.name }}</p>
            </router-link>
            <p class="speaker-position">{{ details.job_title }}</p>
            <router-link :to="{name: 'companyProfile', params: { companyId: details.company_id }}">
              <p class="speaker-company">{{ details.company }}</p>
            </router-link>
          </div>
        </div>
      </b-collapse>
    </b-card>
  </div>
</template>

<script>
export default {
  name: 'MobileAgendaPanelInfo',
  data() {
    return {};
  },
  props: {
    panelInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  methods: {
    getSpeakers(type) {
      return this.panelInfo.members.filter(member => member.type === type);
    },
  },
};
</script>

<style scoped>
.moderator-photo {
  width: 52px;
  height: 52px;
  object-fit: fill;
}
p {
  margin: 0;
}
.speaker-photo-container {
  padding: 0;
  max-width: 52px;
  background-color: #f3f3f3;
}
.speaker-img {
  border: 1px solid #ebebeb;
  max-width: 233px;
  margin: 5px 5px;
  height: 62px;
  cursor: pointer;
}
.speaker-info-container {
  background-color: #f3f3f3;
}
.speaker-info-container > p {
  color: rgb(29, 29, 29);
  line-height: 12px;
  font-size: 9px;
  padding-top: 0;
}
.speaker-info-container a {
  font-size: 11px;
  color: #333333;
}
.speaker-username {
  font-weight: bold;
  text-transform: capitalize;
  margin-top: 3px;
}
.speaker-position {
  text-transform: capitalize;
  color: #333333;
  font-size: 11px;
}
.speaker-company {
  color: #bd9d5f;
  text-transform: capitalize;
  font-size: 11px;
}
.s-heading {
  padding-top: 10px;
  color: #bd9d5f;
  text-transform: uppercase;
  font-size: 14px;
}
.agenda-expanded {
  padding: 5px 0;
  margin: 0 auto;
  width: 90%;
}
.agenda-expanded p,
.agenda-expanded li {
  font-size: 10px;
  padding: 1px 10px;
  background-color: #f3f3f3;
}

.card {
  border-radius: 0 10px 10px 10px;
  overflow: hidden;
}
.card>.card-header>div {
  font-size: 13px;
}
.card>.collapse>.card-body {
  padding: 0;
}
.speaker-row {
  border: 1px solid #ebebeb;
  border-left: 0;
  display: grid;
  grid-template-columns: 52px 1fr;
}
.card > header i {
  position: absolute;
  top: 16px;
  right: 20px;
}
header .fa-chevron-up {
  display: inline-block;
}
header .fa-chevron-down {
  display: none;
}
.card > .collapsed .fa-chevron-down {
  display: inline-block;
}
.card > .collapsed .fa-chevron-up {
  display: none;
}
</style>
